import gql from 'graphql-tag';

/**
 * Could most likely batch and refactor using Fragments.
 */
// @ts-ignore
export const createBatchedTableQuery = (getTableDataInput: any) => {
  const batchedQueryArray = getTableDataInput.map(
    (tableData: any, index: number) => `
      ${`query${index}`}: getTableData(getTableDataInput: {
        workspaceId: "${tableData.workspaceId}",
        tableId: "${tableData.tableId}",
        blockId: "${tableData.blockId}"
      }) {
        id
        columns {
          id
          name
          type
          typeOptions
        }
        rows {
          id
          cells
        }
        views {
          id
          type
          name
          parentRow
          stackedBy
          columns {
            id
            order
            width
            isHidden
            isHiddenInKanban
          }
          rows {
            id
            order
          }
        }
      }
    `,
  );

  const batchedQuery = batchedQueryArray.join('');
  const finalQuery = gql`
    query GetBatchedTableData {
      ${batchedQuery}
    }
  `;
  return finalQuery;
};
